import React from 'react';
import PropTypes from 'prop-types';
import graphql from "babel-plugin-relay/macro";
import {useMutation} from "react-relay";
import * as yup from "yup";
import {yupResolver} from "@hookform/resolvers/yup";
import {toast} from "react-toastify";
import FormModal from "../../../components/common/modals/FormModal";
import {useForm} from "react-hook-form";
import HorizontalFormInput from "../../../components/common/horizontal-form-inputs/HorizontalFormInput";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {bandedSchema, newBandDefaultValues} from "../../../helpers/bandedUtils";

const NewLocationVersionModal = ({showModal, onClose, locationId}) => {
    const mutation = graphql`
    mutation NewLocationVersionModalMutation($locationId: ID!, $name: String!, $description: String!, $effectiveFrom: DateOnly!, $effectiveTo: DateOnly!) {
        location {
            createVersion(input: {locationId: $locationId, name: $name, description: $description, effectiveFrom: $effectiveFrom, effectiveTo: $effectiveTo}) {
                locationVersion {
                    id
                    location {
                        applicableVersion {
                            id
                            name
                            description
                        }
                        versions {
                            ...LocationVersions_Version
                        }
                    }
                }
            }
        }
    }`
    const [commitMutation, isInFlight] = useMutation(mutation);
    const defaultValues = {
        ...newBandDefaultValues,
        locationId: locationId,
        name: '',
        description: '',
    };
    const schema = bandedSchema.shape({
      name: yup.string().required("Name is required"),
      description: yup.string().max(1024)
    });
    const methods = useForm({defaultValues: defaultValues, resolver: yupResolver(schema)});
    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (data) => {
                if(data.location) {
                    toast.success("Version of Location created");
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal}
                   onClose={onClose}
                   title={"New Version of Location"}
                   methods={methods}
                   isInFlight={isInFlight}
                   onSubmit={handleSubmit}
                   buttonText={"Create"}
                   inFlightButtonText={"Creating"}
        >
            <HorizontalFormInput controlId={"name"} label={"Name"} />
            <HorizontalFormInput controlId={"description"} label={"Description"} />
            <HorizontalFormDate controlId={"effectiveFrom"} label={"Effective From"} />
            <HorizontalFormDate controlId={"effectiveTo"} label={"Effective To"} />
        </FormModal>
    )
}
NewLocationVersionModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    locationId: PropTypes.string.isRequired
}
export default NewLocationVersionModal